//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 
//  const GetMultipleOptionId=(data:any)=> request({
//   url: ApiURL.Query.getImageDetailWithMultipleOption,
//   method: RequestType.POST,
//   data:data
//  });

 const GetImageData=(data:any)=> request({
  url: ApiURL.Query.getImageDatas,
  method: RequestType.POST,
  data:data
 });
 const DownloadImage=(data:any)=> request({
  url: ApiURL.Query.downloadImages,
  method: RequestType.POST,
  data:data,
  responseType:"blob",
  skipBlobAutoOpen: true,
 });
 
const ImageSearchServiceQuery = {
  GetImageData,
  DownloadImage
};

export default ImageSearchServiceQuery;
